module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Teleport', {
    attrs: {
      "to": "body"
    }
  }, [_c('Transition', {
    attrs: {
      "name": "modal-fade"
    }
  }, [(_vm.showModal) ? _c('div', {
    staticClass: "modal-mask",
    on: {
      "click": _vm.closeModal
    }
  }, [_c('div', {
    staticClass: "modal-placeholder",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('header', {
    staticClass: "modal-header"
  }, [_vm._t("header", [_c('h3', [_vm._v(_vm._s(_vm.t(_vm.title)))])]), _vm._v(" "), _c('ModalCloseButton')], 2), _vm._v(" "), _c('div', {
    staticClass: "inner",
    style: (_vm.style)
  }, [_c(_vm.mountedComponent, {
    ref: "dynamicChild",
    tag: "component",
    attrs: {
      "config": _vm.config,
      "eventData": _vm.eventData,
      "eventBus": _vm.$root
    }
  })], 1)])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5444e201!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/ModalFactory.vue
// module id = 1293
// module chunks = 2